module.exports = __webpack_public_path__ + "img/s2P13.54a2c480.png";